import React, {Suspense} from "react";
import {Redirect, Switch} from "react-router-dom";
import CommentsPage from "./pages/CommentsPage";
import {LayoutSplashScreen, ContentRoute} from "../../../_metronic/layout/index";

export default function commentModule() {
    return (
        <Suspense fallback={<LayoutSplashScreen/>}>
            <Switch>
                <ContentRoute path="/comments" component={CommentsPage}/>
            </Switch>
        </Suspense>
    );
}
